
import state from './moduleMasterStepsManagementState'
import mutations from './moduleMasterStepsManagementMutations'
import actions from './moduleMasterStepsManagementActions'
import getters from './moduleMasterStepsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

